import React, { useState, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";
// Ajusta la ruta según tu proyecto

const Create = () => {
  const { dbCategories, loadProducts } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([null, null, null, null]);
  const [previews, setPreviews] = useState(["", "", "", ""]);

  const initialForm = {
    titulo: "",
    global_type: "Recetados",
    categoria: "",
    precio: "",
    stock: "",
    descripcion: "",
    alto: "",
    ancho: "",
    patilla: "",
    estado: "activo",
  };

  const [formData, setFormData] = useState(initialForm);

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);
      const newPreviews = [...previews];
      newPreviews[index] = URL.createObjectURL(file);
      setPreviews(newPreviews);
    }
  };

  const removeImage = (index) => {
    const newPreviews = [...previews];
    newPreviews[index] = "";
    setPreviews(newPreviews);
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };

  const handleClose = () => {
    setShow(false);
    setFormData(initialForm);
    setImages([null, null, null, null]);
    setPreviews(["", "", "", ""]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();

    // Pasamos los datos del formulario al FormData
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));

    // Pasamos las imágenes
    images.forEach((file, i) => {
      if (file) data.append(`image_${i}`, file);
    });

    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/save_product.php",
        {
          method: "POST",
          body: data,
          // --- ESTO ES LO QUE AGREGA SEGURIDAD ---
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        Swal.fire("Éxito", "Producto creado correctamente", "success");
        await loadProducts(); // Esperamos que cargue antes de cerrar
        handleClose();
      } else {
        // Si el PHP nos rebota (ej: 403), mostramos el mensaje de error
        Swal.fire(
          "Error",
          res.message || "No tenés permiso para crear",
          "error",
        );
      }
    } catch (err) {
      console.error("Error al crear:", err);
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="boton" onClick={() => setShow(true)}>
        + Nuevo Producto
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Nuevo Producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* IMÁGENES */}
            <div className="row g-2 mb-3">
              {[0, 1, 2, 3].map((i) => (
                <div key={i} className="col-3 position-relative">
                  <div
                    onClick={() =>
                      document.getElementById(`file-create-${i}`).click()
                    }
                    className="border rounded d-flex align-items-center justify-content-center bg-light shadow-sm"
                    style={{
                      height: "100px",
                      cursor: "pointer",
                      overflow: "hidden",
                    }}
                  >
                    {previews[i] ? (
                      <img
                        src={previews[i]}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                    ) : (
                      <i className="bi bi-camera fs-2 text-muted"></i>
                    )}
                  </div>
                  {previews[i] && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm position-absolute"
                      style={{
                        top: "5px",
                        right: "10px",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        zIndex: 10,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeImage(i);
                      }}
                    >
                      <i className="bi bi-trash-fill small"></i>
                    </button>
                  )}
                  <input
                    type="file"
                    id={`file-create-${i}`}
                    hidden
                    onChange={(e) => handleImageChange(i, e)}
                  />
                </div>
              ))}
            </div>

            {/* CATEGORÍA DESDE DB */}
            <div className="mb-3">
              <Form.Label className="small fw-bold">Categoría</Form.Label>
              <Form.Select
                required
                value={formData.categoria}
                onChange={(e) =>
                  setFormData({ ...formData, categoria: e.target.value })
                }
              >
                <option value="">Seleccionar categoría...</option>
                {dbCategories.map((cat) => (
                  <option key={cat.id} value={cat.nombre}>
                    {cat.nombre}
                  </option>
                ))}
              </Form.Select>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Título</Form.Label>
              <Form.Control
                placeholder="Ej: Ray-Ban Wayfarer"
                required
                value={formData.titulo}
                onChange={(e) =>
                  setFormData({ ...formData, titulo: e.target.value })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.descripcion}
                onChange={(e) =>
                  setFormData({ ...formData, descripcion: e.target.value })
                }
              />
            </Form.Group>

            <div className="row mb-3">
              <div className="col">
                <Form.Label className="small fw-bold">Precio ($)</Form.Label>
                <Form.Control
                  type="number"
                  required
                  value={formData.precio}
                  onChange={(e) =>
                    setFormData({ ...formData, precio: e.target.value })
                  }
                />
              </div>
              <div className="col">
                <Form.Label className="small fw-bold">Stock</Form.Label>
                <Form.Control
                  type="number"
                  required
                  value={formData.stock}
                  onChange={(e) =>
                    setFormData({ ...formData, stock: e.target.value })
                  }
                />
              </div>
            </div>

            {/* MEDIDAS */}
            <div className="row g-2 p-3 border rounded bg-light">
              <div className="col-12">
                <small className="fw-bold text-muted text-uppercase">
                  Medidas (mm)
                </small>
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Alto</Form.Label>
                <Form.Control
                  value={formData.alto}
                  onChange={(e) =>
                    setFormData({ ...formData, alto: e.target.value })
                  }
                />
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Ancho</Form.Label>
                <Form.Control
                  value={formData.ancho}
                  onChange={(e) =>
                    setFormData({ ...formData, ancho: e.target.value })
                  }
                />
              </div>
              <div className="col-4">
                <Form.Label className="small mb-0">Patilla</Form.Label>
                <Form.Control
                  value={formData.patilla}
                  onChange={(e) =>
                    setFormData({ ...formData, patilla: e.target.value })
                  }
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              CANCELAR
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "GUARDANDO..." : "CREAR PRODUCTO"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Create;
